import { ILibraryPlace } from "../../src/taskpane/services/copilot/copilotFileRefs";

/**
 * The library rows being dragged, for the Copilot pane's drop target (spec 2026-10-22 §2.5, §2.12). A
 * drag's data can't be read before its drop, so the library grid leaves its rows here when a row drag
 * starts and clears them when it ends; the pane counts what a drop would add while the drag is over it.
 * In memory only: nothing is persisted.
 */
export interface ICopilotDragSource {
  /** The grid's raw rows (RenderListDataAsStream), as the drag carries them. */
  rows: any[];
  /** Where they are: the grid's place, which the refs are built from. */
  place: ILibraryPlace;
}

/** The library grid's own drag type (DragAndDropHelper.gridDataTransferType), named here so the pane
 * doesn't load DragAndDropHelper and its upload and copy services. */
export const LIBRARY_ROW_DRAG_TYPE: string = "griditem";

let dragSource: ICopilotDragSource | null = null;

export const setCopilotDragSource = (source: ICopilotDragSource | null): void => {
  dragSource = source;
};

export const getCopilotDragSource = (): ICopilotDragSource | null => dragSource;

const hasType = (types: ArrayLike<string>, type: string): boolean => Array.prototype.indexOf.call(types, type) !== -1;

/** A drag of library rows: the grid's own type, and no desktop files. DataTransfer.types is an array in
 * today's browsers and a DOMStringList in older ones, so it is read by index. */
export const isLibraryRowDrag = (dataTransfer: { types?: ArrayLike<string> } | null | undefined): boolean => {
  const types: ArrayLike<string> | undefined = dataTransfer?.types;
  return !!types && hasType(types, LIBRARY_ROW_DRAG_TYPE) && !hasType(types, "Files");
};
